import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { customerShipmentsList } from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

import moment from "moment";
const Shipments = () => {
  const dispatch = useDispatch();
  const shipment_list = useSelector(
    (state) => state?.shipNPay?.customer_shipments_list
  );
  const history = useHistory();
  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(customerShipmentsList(obj));
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      header: "DO Number",
      accessor: "DeliveryNo",
      width: 8,
    },
    {
      header: "Container No",
      accessor: "Container",
      width: 10,
    },
    {
      header: "Quantity",
      accessor: "Kwmeng",
      width: 8,
      cell: (row) => <span>{parseInt(row.Kwmeng)}</span>,
    },
    {
      header: "Reference SO",
      accessor: "SoNumber",
      width: 10,
    },
    {
      header: "Reference PO",
      accessor: "PoNum",
      width: 10,
    },
    {
      header: "ETA",
      accessor: "EtaDate",
      width: 7,
    },
    {
      header: "ETD",
      accessor: "EtdDate",
      width: 7,
    },
    {
      header: "PSA Status",
      accessor: "PiStatus",
      width: 10,
      cell: (row) => <span className="text-btn">{row.PiStatus}</span>,
      className: "psa_status",
    },
    {
      header: "Shipment Status",
      accessor: "ShipStatus",
      width: 10,
      cell: (row) => <span className="success-text">{row.ShipStatus}</span>,
    },
    {
      header: "Delivery Address",
      accessor: "Street",
      width: 10,
      cell: (row) => (
        <span>
          {row.Street}, {row.City1}, {row.Country}
        </span>
      ),
    },
    {
      header: "Vessel Name",
      accessor: "Description",
      width: 10,
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Shipments"}
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
          namedFilters={[
            "All (27)",
            "Planned Shipments (12)",
            "In-Transit (14)",
            "Completed (1)",
            "PSA Cancelled (1)",
          ]}
          isDateFilter={true}
          options={[{ label: "All Dates", value: "all" }]}
          label={""}
          total_count={shipment_list?.data?.length}
          loading={shipment_list?.loading}
          perPageLimit={shipment_list?.data?.length}
        >
          <Table
            columns={columns}
            data={shipment_list?.data}
            action={false}
            actionWidth={8}
            onRowClick={(row) => {
              history.push("/admin/shipment-doc", {
                delNo: row.DeliveryNo,
                order_no: row.DeliveryNo,
                time: moment(row?.SoDate, "YYYYMMDD").format("DD MMM, YYYY"),
              });
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Shipments;
